/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Bom_Rule_Products_UseInputs */

const vi_packaging_bom_rule_products_use = /** @type {(inputs: Packaging_Bom_Rule_Products_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sản phẩm dùng`)
};

/**

* @param {Packaging_Bom_Rule_Products_UseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_bom_rule_products_use = /** @type {((inputs?: Packaging_Bom_Rule_Products_UseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Bom_Rule_Products_UseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_bom_rule_products_use(inputs)
});